// extracted by mini-css-extract-plugin
module.exports = {"memberDetails":"jgp-1RFEY","donate":"jgp-3qL71","cancelled":"jgp-3wKvi"};